
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TFunction } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ApiButton, Button, ContentTemplate, Grid, Typography } from 'web-library';
import { IDropdown, IOpsAdminData } from './OpsAdminForm';
import RouteKey from '../../../../routes/key';

interface IOpsAdminButtonProps {
  formData: IOpsAdminData;
  classes: Record<string,string>;
  formHook: UseFormReturn<any>;
  t: TFunction<'translation'>;
  disableButton: boolean;
  hasEditAccess: boolean;
}

const { admin } = RouteKey.child;

const { nonNationalExamApplication } = RouteKey.admin.child;

const OpsAdminButton = (props: IOpsAdminButtonProps) => {
  const { formData, classes, formHook, t, disableButton = true, hasEditAccess } = props;
  const { getValues, handleSubmit } = formHook;
  const history = useHistory();

  const submitButtonClick = () => {
    handleSubmit((submitData) => {
      if (!formData.applicationStatusData.lockedByUser) {
        const applicationStatus: IDropdown = getValues('applicationStatus');
        formData.putNonNationalExamApplicationStatus.mutate({
          status: applicationStatus && applicationStatus.code ? applicationStatus.code : null,
          candidateRemark: getValues('candidateRemarks'),
          internalRemark: getValues('internalRemarks'),
        });
      }
    })();
  };

  return (
    <ContentTemplate continuous>
      {formData.applicationStatusData.lockedByUser && (
        <Typography variant="body2" className={classes.errorText}>
          {t('exam->>NonNationalExam.LockedMessage', {
            lockedByUser: formData.applicationStatusData.lockedByUser,
          })}
        </Typography>
      )}
      {formData.applicationStatusData.editable && (
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          spacing={3}
          className={classes.twinButtonGroup}
        >
          <Grid xs={12} md={hasEditAccess ? 3 : 6}>
            <Button
              id="button-back"
              fullWidth
              className={classes.button}
              variant="outlined"
              onClick={() => {
                history.goBack();
              }}
            >
              {t('exam->>ReviewExam.Back')}
            </Button>
          </Grid>
          {hasEditAccess && (
            <Grid xs={12} md={4}>
              <ApiButton
                id="button-updateApplication"
                fullWidth
                className={classes.button}
                type="button"
                status={formData.putNonNationalExamApplicationStatus.status}
                onClick={submitButtonClick}
                disabled={!!formData.applicationStatusData.lockedByUser || disableButton}
              >
                {t('exam->>ReviewExam.Update Application')}
              </ApiButton>
            </Grid>
          )}
        </Grid>
      )}
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        spacing={3}
        className={classes.bottomButtonGroup}
      >
        <Grid xs={12} md={6}>
          <Button
            id="button-backToList"
            fullWidth
            className={classes.button}
            variant="outlined"
            onClick={() => {
              history.push(`/${admin}/${nonNationalExamApplication.route}`);
            }}
          >
            {t('exam->>ReviewExam.BackToApplicationList')}
          </Button>
        </Grid>
      </Grid>
    </ContentTemplate>
  );
};

export default OpsAdminButton;
